var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:[_vm.hFull ? 'h-full' : '', _vm.wFull ? 'w-full' : ''],attrs:{"src":_vm.generatedSrc,"srcset":_vm.cldnSrcSet,"sizes":_vm.sizes,"loading":_vm.loading,"alt":_vm.alt === '' ? false : _vm.alt,"data-prop-issues":_vm.propIssues}})
}
var staticRenderFns = []

export { render, staticRenderFns }